import * as React from "react";
import { tokens } from "@fluentui/react-components";
import {
  Image24Regular,
  Document24Regular,
  DocumentPdf24Regular,
  DocumentText24Regular,
  DocumentTable24Regular,
} from "@fluentui/react-icons";

export function getExtension(fileName: string): string {
  const dotIndex = fileName.lastIndexOf(".");
  return dotIndex === -1 ? "" : fileName.slice(dotIndex + 1).toLowerCase();
}

/** Icon + brand-neutral color for a file, based on its extension (not the deprecated `contentType`). */
export function getAttachmentIcon(fileName: string): { icon: React.ReactElement; color: string } {
  const ext = getExtension(fileName);

  if (ext === "pdf") {
    return { icon: <DocumentPdf24Regular />, color: tokens.colorPaletteRedForeground1 };
  }
  if (["doc", "docx", "rtf", "odt"].includes(ext)) {
    return { icon: <DocumentText24Regular />, color: tokens.colorPaletteBlueForeground2 };
  }
  if (["xls", "xlsx", "csv"].includes(ext)) {
    return { icon: <DocumentTable24Regular />, color: tokens.colorPaletteGreenForeground1 };
  }
  if (["png", "jpg", "jpeg", "gif", "bmp", "webp", "svg"].includes(ext)) {
    return { icon: <Image24Regular />, color: tokens.colorNeutralForeground3 };
  }
  return { icon: <Document24Regular />, color: tokens.colorNeutralForeground3 };
}
